import { render } from "./MyIndexPage.vue?vue&type=template&id=7841ee62&scoped=true"
const script = {}

import "./MyIndexPage.vue?vue&type=style&index=0&id=7841ee62&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7841ee62"]])

export default __exports__